import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { FilterFieldGroup, Item, SortingFieldGroup } from "../../../Models";
import { getValueByLang } from "../../../Utils";
import {SvgIcon} from '../../common/MaterialDesignComponents';

interface Attrs{
    messageProvider: MessageProvider
    filterFieldGroup: FilterFieldGroup
    sortingFieldGroup: SortingFieldGroup
    onFilterPriceRangeSelected: (value:string|null) => void
    onSortByPriceSelected: (sortByPrice: string|null) => void
}

function HotelResultFilterComponent(): m.Component<Attrs> {
    
    let priceRangeItems:Item[] = [];
    let sortingModeItems: Item[] = [];

    return {
        oninit(vnode) {
            priceRangeItems = vnode.attrs.filterFieldGroup.priceRangeOption.items.map(item => {
                return {...item};
            });

            sortingModeItems = vnode.attrs.sortingFieldGroup.priceSortingOption.items.map(item => {
                return {...item};
            });
        },
        
        view(vnode) {
            const { messageProvider, onFilterPriceRangeSelected, onSortByPriceSelected} = vnode.attrs;

            return [
                m(FilterSection, {
                    title: messageProvider.get("sorting_price") 
                    
                }, [ 
                    m("div.row", [
                        sortingModeItems.map(function(priceSorting, index){
                            return m("div.col-12 col-lg-6 pt-2", {
                                onclick: function(event) {   
                                    sortingModeItems.forEach((item, i) => {
                                        item.isSelected = (i == index);
                                    });
                                    
                                    onSortByPriceSelected(priceSorting.value);
                                }
                            }, [
                                m("div.d-flex", [
                                    m("div.align-self-center", [
                                        (priceSorting.isSelected)?
                                        m(SvgIcon, {
                                            iconType:'radio_button_checked',
                                            colorScheme:'primary',
                                            sizeScheme: "small"
                                        }):
                                        m(SvgIcon, {
                                            iconType:'radio_button_unchecked',
                                            color: 'black',
                                            sizeScheme: "small"
                                        }
                                        )
                                    ]),
                                    m("div.pl-2 clickable", getValueByLang(priceSorting.label, messageProvider.getCurrentLang()))
                                ])
                            ])
                        })
                    ])
                ]),   

                (priceRangeItems.length > 0)?
                m("div.mt-4", [
                    m(FilterSection, {
                        title: messageProvider.get("price_range") + " (MMK)"
                    },[ 
                        m("div.row", [
                            priceRangeItems.map(function(item, index){
                                return m("div.col-12 col-lg-6 pt-2", {
                                    onclick: function(event){
                                        event.preventDefault();
                                        priceRangeItems.forEach((item, i) => {
                                            item.isSelected = (i == index);
                                        });
                                        onFilterPriceRangeSelected(item.value);
                                    }
                                }, [
                                    m("div.d-flex", [
                                        m("div.pr-2 align-self-center", [
                                            (item.isSelected)?
                                            m(SvgIcon, {
                                                iconType: "radio_button_checked",
                                                colorScheme: "primary",
                                                sizeScheme: "small"
                                            }):
                                            m(SvgIcon, {
                                                iconType: "radio_button_unchecked",
                                                color: "black",
                                                sizeScheme: "small"
                                            })
                                        ]),
                                        m("div.clickable", getValueByLang(item.label, messageProvider.getCurrentLang()))
                                    ])
                                    
                                ])
                            })
                        ]),

                        (priceRangeItems.filter(tempPriceRange => tempPriceRange.isSelected).length > 0)?
                        m("a.ml-1", {
                            href:"#",
                            onclick: function(event){
                                event.preventDefault();
                                priceRangeItems.forEach(tempPriceRange => tempPriceRange.isSelected = false)

                                onFilterPriceRangeSelected(null);
                            }
                        }, [
                            m("div.d-flex", [
                                m("div.align-self-center",  m("i.fa fa-times pr-2")),
                                m("div", messageProvider.get("clear_price_range"))  
                            ])                  
                        ])
                        :null
                    ])
                ]):null 
            ]       
        }
    }
};

function FilterSection(): m.Component<{title:string}> {
    return {
        view(vnode) {
            return m("div", [
                m("strong.text-muted", vnode.attrs.title),
                m("div.mt-3", 
                    vnode.children
                )
            ]);
        }
    }
}

export default HotelResultFilterComponent;

